export class LocalStorageModel {
    account?: { isLogged?: boolean };
    recentKeywords?: string[];
}

export type LocalStorageKeys = (keyof LocalStorageModel) | string;
